import { ReactLocalization } from "@fluent/react";
import { FluentBundle, FluentResource } from "@fluent/bundle";
import messages from "./messages.ftl?raw";

const getLocalizationInfo = (messagesStr: string) => {
  const bundle = new FluentBundle(["en-US"]);
  const resource = new FluentResource(messagesStr);
  bundle.addResource(resource);
  function* generateBundles(_locales: string[]) {
    yield bundle;
  }
  const localization = new ReactLocalization(generateBundles(["en-US"]));

  return localization;
};

const localization = getLocalizationInfo(messages);

export default localization;
